export const COVER_DATE_FORMAT = 'dddd, MMMM Do YYYY'
export const DMY_DATE_FORMAT = 'DD/MM/YYYY'
export const US_DATE_FORMAT = 'MM/DD/YYYY'
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'
export const ISO_DATE_SHORT_FORMAT = 'YYYY-MM'
export const PICKER_DATE_FORMAT = 'ddd, DD MMM YYYY'
export const DMY_CASUAL_FORMAT = 'DD MMM YYYY'
export const DMY_CASUAL_SHORT_FORMAT = 'D MMM YYYY'
export const DMY_CASUAL_SHORT_DAY_SUFFIX_FORMAT = 'Do MMM YYYY'
export const US_CASUAL_FORMAT = 'MMM DD YYYY'
export const MD_CASUAL_FORMAT = 'MMM DD'
export const MDY_CASUAL_FORMAT_COMMA_SHORT = 'MMM D, YYYY'
export const ISO_DMY_TIME_FORMAT = 'YYYY-MM-DD h:mm:ssa'
export const SHORT_DAY_NAME_DAY_MONTH = 'ddd, D MMM'
export const SHORT_DAY_NAME_DAY_MONTH_NO_COMMA = 'ddd D MMM'
export const SHORT_DAY_NAME_DAY_MONTH_YEAR = 'ddd, D MMM YYYY'
export const SHORT_DAY_NAME_DAY_MONTH_YEAR_NO_COMMA = 'ddd D MMM YYYY'
export const DAY_MONTH_NAME = 'DD MMM'
export const DAY_MONTH_NAME_SHORT = 'D MMM'
export const ACCOMMODATION_TIME_FORMAT = 'ddd, DD MMM, YYYY'
export const DATE_TIME_FORMAT = 'ddd, DD MMM, YYYY - h:mma'
export const DAY_SHORT_MONTH_COMMA_LONG_YEAR = 'DD MMM, YYYY'
export const LONG_MONTH_LONG_YEAR = 'MMMM YYYY'
export const SHORT_MONTH_LONG_YEAR = 'MMM YYYY'
export const SHORT_DATE_TIME_FORMAT = 'ddd D MMM, h:mma'
export const SHORT_TIME_FORMAT = 'hh:mm'
export const SHORT_TIME_FORMAT_AM_PM = 'hh:mma'
export const SHORT_TIME_FORMAT_SEPARATE_AM_PM = 'hh:mm a'
export const SHORT_TIME_HOUR_FORMAT_AM_PM = 'h:mma'
export const SHORT_TIME_HOUR_FORMAT_AM_PM_UPPERCASE = 'h:mm A'
export const SHORT_TIME_FORMAT_24_HOUR = 'HH:mm'
export const LONG_MONTH = 'MMMM'
export const LOCALIZED_LONG_DATE = 'LL'
export const LOCALIZED_SHORT_TIME_FORMAT_AM_PM = 'LT'

export const INTL_DAY_SHORT_MONTH_COMMA_LONG_YEAR: Intl.DateTimeFormatOptions[] = [
  {
    day: 'numeric',
    month: 'short',
  },
  { year: 'numeric' },
]

export const INTL_DAY_LONG_MONTH_LONG_YEAR: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' }

export const INTL_SHORT_WEEKDAY_COMMA_DAY_SHORT_MONTH_LONG_YEAR: Intl.DateTimeFormatOptions[] = [
  { weekday: 'short' },
  {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  },
]
